/* ================================ EMPLOYEE MENU ================================*/
export const MENU_HOME = 'HOME';
export const MENU_PUNCH = 'PUNCH';
export const MENU_PUNCHCCQ = 'PUNCHCCQ';
export const MENU_TIMESHEET = 'TIMESHEET';
export const MENU_SCHEDULE = 'SCHEDULE';
export const MENU_DOCUMENTS = 'DOCUMENTS';
export const MENU_EXPENSES = 'EXPENSES';
export const MENU_REQUEST = 'REQUEST';
export const MENU_HRREQUEST = 'HRREQUEST';
export const MENU_SETTINGS = 'SETTINGS';
export const MENU_PROFILE = 'PROFILE';
export const MENU_SCHEDULEAVAILABILITY = 'SCHEDULEAVAILABILITY';
export const MENU_SURVEY = 'SURVEYS';
export const MENU_BANKBALANCE = 'SOLDEBQ';
export const MENU_MATERIALRESOURCES = 'MATERIALRESOURCES';
export const MENU_PAYROLLREGISTER = 'PAYROLLREGISTER';
export const MENU_CHAT = 'CHAT';

export const TAB_AVAILABILITY = 'AVAILABILITY';
export const TAB_EXCEPTION = 'EXCEPTION';
export const TAB_EMERGENCYCONTACTS = 'EMERGENCYCONTACTS';
export const TAB_BANKBALANCEVACATION = 'BANKBALANCEVACATION';
export const TAB_BANKBALANCEOTHERS = 'BANKBALANCEOTHERS';
export const TAB_PAYSTUBS = 'DOCPAYSTUBS';
export const TAB_YEAREND = 'DOCYEAREND';
export const TAB_DOCUMENTS = 'DISTRIBUTEDDOCUMENTS';
export const TAB_PROFILEDET = 'PROFILEDET';
/* ================================ EMPLOYEE MENU ================================*/


/* ================================ SUPERVISOR MENU ================================*/
export const MENU_SUP_HOME = 'SUPHOME';
export const MENU_SUP_DOCUMENTS = 'SUPDOCUMENTS';
export const MENU_SUP_PUNCHAPPROVAL = 'SUPPUNCHAPPROVAL';
export const MENU_SUP_REQUESTS = 'SUPREQUESTS';

export const TAB_SUP_APPROVALCENTRAL = 'SUPAPPROVALCENTRAL';
export const TAB_SUP_REQUESTCALENDAR = 'SUPAPPROVALREQUESTCALENDAR';
/* ================================ SUPERVISOR MENU ================================*/